import React from 'react';
import { Typography } from '@guildeducationinc/recess';
import styles from './Tuition.module.scss';

export const RemainingCostsPopoverContent: React.FC = () => {
	return (
		<Typography className={styles.remainingCostsPopover} variant='label2'>
			This is an estimate of the remaining cost after your employer funding is applied. This does
			not include:
			<ul>
				<li>Previous funding used</li>
				<li>Financial aid</li>
				<li>Books & fees</li>
				<li>Enrollment fees</li>
				<li>Personal expenses</li>
			</ul>
			Actual out of pocket costs may vary.
		</Typography>
	);
};
